module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.eot";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
// module id = 479
// module chunks = 14